import "./search-sort";
import "./search-filter";

class MainSearch extends HTMLElement {
  constructor() {
    super();
    this.el = this;
    this.url = this.getAttribute("url");
    this.searchInput = this.querySelector("[data-search-input]");
    this.results = this.querySelector("[data-results]");
    this.collectionResults = this.querySelector("[data-collection-results]");
    this.productResults = this.querySelector("[data-product-results]");
    this.articleResults = this.querySelector("[data-article-results]");
    this.buttonLanding = this.querySelector("[data-button-landing]");
    this.term = this.querySelector("[data-term]");
    this.form = this.querySelector("form");
    this.titleEl = this.querySelector("[data-title]");
    this.toggleFilterButton = this.querySelector("[data-toggle-filter]");
    //this.handleTabClick = this.handleTabClick.bind(this);
  }

  connectedCallback() {
    this.setupListeners();
    this.setupInfiniteScroll();

    // if (this.form && this.searchInput) {
    //   this.form.addEventListener("submit", (event) => {
    //     event.preventDefault();
    //     this.getSearchResults(this.searchInput.value);
    //   });
    // }

    const urlParams = new URLSearchParams(window.location.search);
    const initialQuery = urlParams.get("q");

    if (initialQuery) {
      this.searchInput.value = initialQuery;
      this.getSearchResults(initialQuery);
    }

    const ariaExpanded = this.toggleFilterButton?.getAttribute("aria-expanded");
    this.filterIsOpen = ariaExpanded === "true";

    this.filterIsOpen = true;

    this.addEventListener("mobile-filter:open", () => {
      if (window.matchMedia("(max-width: 960px)").matches) {
        document.body.classList.toggle("mobile-filter-open", this.filterIsOpen);
        const promoBarHeight =
          document.querySelector(".promo-bar")?.offsetHeight;

        if (promoBarHeight) {
          document.documentElement.style.setProperty(
            "--collection-filter-top",
            `${promoBarHeight}px`,
          );
        }

        document.documentElement.style.overflow = this.filterIsOpen
          ? "hidden"
          : "auto";
      } else {
        this.toggleFilterButton?.setAttribute(
          "aria-expanded",
          this.filterIsOpen,
        );
      }

      if (!this.filterIsOpen) {
        this.classList.add("filters--closing");
        document.body.classList.remove("mobile-filter-open");
        document.documentElement.style.overflow = "auto";
        this.toggleFilterButton?.setAttribute("aria-expanded", false);

        setTimeout(() => {
          this.classList.remove("filters--closing", "filters--visible");
        }, 200);
      } else {
        this.toggleFilterButton?.setAttribute("aria-expanded", true);
        this.classList.add("filters--visible", "filters--animated");
        setTimeout(() => {
          this.classList.remove("filters--animated");
        }, 200);
      }

      this.filterIsOpen = !this.filterIsOpen;
    });

    window.addEventListener("resize", () => {
      if (window.innerWidth < 960) {
        this.filterIsOpen = true;
        this.classList.add("filters--closing");
        document.body.classList.remove("mobile-filter-open");
        document.documentElement.style.overflow = "auto";
        this.toggleFilterButton?.setAttribute("aria-expanded", false);

        setTimeout(() => {
          this.classList.remove("filters--closing", "filters--visible");
        }, 200);
      }
    });

    this.addEventListener("mobile-filter:close", () => {
      this.filterIsOpen = true;
      this.classList.add("filters--closing");
      document.body.classList.remove("mobile-filter-open");
      document.documentElement.style.overflow = "auto";
      this.toggleFilterButton?.setAttribute("aria-expanded", false);

      setTimeout(() => {
        this.classList.remove("filters--closing", "filters--visible");
      }, 200);
    });

    this.toggleFilterButton?.addEventListener("click", (e) => {
      e.preventDefault();
      const event = new CustomEvent("mobile-filter:open", { bubbles: true });
      this.dispatchEvent(event);
    });
  }

  setupInfiniteScroll() {
    const sentinel = this.querySelector("[data-load-more]");
    const productGrid = this.querySelector("[data-product-results]");
    const wrapper = this.querySelector("[data-load-more-wrapper]");
    if (!sentinel || !productGrid) return;

    // Prevent multiple simultaneous fetches
    let loading = false;

    const observer = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting || loading) return;

          loading = true;
          observer.unobserve(entry.target);

          sentinel.setAttribute("disabled", true);
          sentinel.textContent = "Loading...";

          fetch(sentinel.href)
            .then((res) => res.text())
            .then((html) => {
              const parser = new DOMParser();
              const doc = parser.parseFromString(html, "text/html");

              const newProducts = doc.querySelectorAll(
                "[data-product-results] > *",
              );
              const newWrapper = doc.querySelector("[data-load-more-wrapper]");
              const newButton = doc.querySelector("[data-load-more]");

              newProducts.forEach((product) =>
                productGrid.appendChild(product),
              );

              if (wrapper) wrapper.remove();

              if (newWrapper && newButton) {
                productGrid.appendChild(newWrapper);
                this.setupInfiniteScroll();
              }

              loading = false;
            })
            .catch((err) => {
              console.error("Infinite scroll failed:", err);
              sentinel.textContent = "Error";
              loading = false;
            });
        });
      },
      {
        rootMargin: "200px",
      },
    );

    observer.observe(sentinel);
  }

  getSearchResults(q) {
    if (!q) return;

    let requestResponse;
    if (this.collectionResults) this.collectionResults.innerHTML = "";
    //if (this.productResults) this.productResults.innerHTML = "";
    if (this.articleResults) this.articleResults.innerHTML = "";
    if (this.term) this.term.innerHTML = q;

    const collectionButton = this.buttonLanding?.querySelector(
      '[data-tab-button="collections"]',
    );
    //const productButton = this.buttonLanding?.querySelector('[data-tab-button="products"]');
    const articleButton = this.buttonLanding?.querySelector(
      '[data-tab-button="articles"]',
    );
    if (collectionButton) this.buttonLanding.removeChild(collectionButton);
    //if (productButton) this.buttonLanding.removeChild(productButton);
    if (articleButton) this.buttonLanding.removeChild(articleButton);

    fetch(`${this.url}?q=${q}&section_id=search-results`)
      .then((response) => {
        requestResponse = response;
        return response.text();
      })
      .then((text) => {
        if (!requestResponse.ok)
          throw new Error(`${requestResponse.status}: ${text}`);

        const html = new DOMParser().parseFromString(text, "text/html");

        const collectionButtonMarkup = html.querySelector(
          `#shopify-section-search-results [data-tab-button="collections"]`,
        );
        //const productButtonMarkup = html.querySelector(`#shopify-section-search-results [data-tab-button="products"]`);
        const articleButtonMarkup = html.querySelector(
          `#shopify-section-search-results [data-tab-button="articles"]`,
        );

        if (collectionButtonMarkup)
          this.buttonLanding?.prepend(collectionButtonMarkup);
        //if (productButtonMarkup) this.buttonLanding?.prepend(productButtonMarkup);
        if (articleButtonMarkup)
          this.buttonLanding?.append(articleButtonMarkup);

        const collectionResults = html.querySelector(
          `#shopify-section-search-results [data-tab="collections"]`,
        );
        //const productResults = html.querySelector(`#shopify-section-search-results [data-tab="products"]`);
        const articleResults = html.querySelector(
          `#shopify-section-search-results [data-tab="articles"]`,
        );

        if (collectionResults) this.collectionResults.append(collectionResults);
        //if (productResults) this.productResults.append(productResults);
        if (articleResults) this.articleResults.append(articleResults);

        const formData = new FormData(this.form);
        const searchParams = new URLSearchParams(formData);
        const url = new URL(window.location.href);
        searchParams.forEach((value, key) => {
          url.searchParams.set(key, value);
        });

        this.titleEl?.classList.remove("hidden");
        history.replaceState("", "", url);
        this.setupListeners();
      })
      .catch(console.error);
  }

  setupListeners() {
    const tabButtons = this.querySelectorAll("[data-tab-button]");
    const tabs = this.querySelectorAll("[data-tab]");

    if (!tabButtons.length || !tabs.length) return;

    tabButtons.forEach((button) => button.classList.remove("active"));
    tabs.forEach((tab) => tab.classList.remove("active"));

    // tabButtons[0]?.classList.add("active");
    // tabs[0]?.classList.add("active");

    const defaultTab = this.activeTab || "products";
    const activeButton = Array.from(tabButtons).find(
      (btn) => btn.dataset.tabButton === defaultTab,
    );
    const activeTab = Array.from(tabs).find(
      (tab) => tab.dataset.tab === defaultTab,
    );

    if (activeButton) activeButton.classList.add("active");
    if (activeTab) activeTab.classList.add("active");

    tabButtons.forEach((button) => {
      button.removeEventListener("click", this.handleTabClick);
      button.addEventListener("click", this.handleTabClick);
    });
  }

  handleTabClick(event) {
    const mainSearch = event.currentTarget.closest("main-search");
    const button = event.currentTarget;
    const buttonValue = button.dataset.tabButton;

    const tabButtons = mainSearch.querySelectorAll("[data-tab-button]");
    const tabs = mainSearch.querySelectorAll("[data-tab]");

    tabButtons.forEach((b) => b.classList.remove("active"));
    tabs.forEach((t) => t.classList.remove("active"));

    button.classList.add("active");

    const activeTab = mainSearch.querySelector(`[data-tab="${buttonValue}"]`);
    if (activeTab) activeTab.classList.add("active");

    this.activeTab = buttonValue;
  }
}

if (!customElements.get("main-search")) {
  customElements.define("main-search", MainSearch);
}
